import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { combineReducers } from 'redux-seamless-immutable'
import reduxCatch from 'redux-catch'

import * as reducers from './reducers'

function errorHandler(error, getState, lastAction) {
  /* eslint-disable no-console */
  console.error(error)
  console.debug('current state', getState())
  console.debug('last action was', lastAction)
  /* eslint-enable no-console */
}

export default function () {
  const reducer = combineReducers({
    ...reducers,
  })

  let composeEnhancers = compose

  if (process && process.env && process.env.BLOKABLE_ENV && process.env.BLOKABLE_ENV !== 'production') {
    // eslint-disable-next-line max-len
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // eslint-disable-line no-underscore-dangle
  }

  const store = createStore(
    reducer,
    /* persistedState, */
    composeEnhancers(
      applyMiddleware(thunkMiddleware),
      applyMiddleware(reduxCatch(errorHandler)),
    ),
  )
  return store
}
